import React from 'react';
import { useLocation } from 'react-router-dom';
import Fsn223WebView from '../screen/Fsn223WebView';
import Fsn41PrivacySettings from '../ui/settings/Fsn41PrivacySettings';
import Fsn44ProfileSetting from '../ui/settings/Fsn44ProfileSetting';
import Fsn136ChallengeLanding from '../screen/Fsn136ChallengeLanding';
import Fsn37EditProfile from '../ui/settings/Fsn37EditProfile';
import Fsn170Support from '../ui/settings/Fsn170Support';
import Fsn40Prefrences from '../ui/settings/Fsn40Prefrences';
import Fsn76GenericUi from '../screen/Fsn76GenericUi';
import Fsn61WebView from '../screen/Fsn61WebView';
import Fsn29CoachSelections from '../screen/Fsn29CoachSelections';
import Fsn193MyProfile from '../ui/profile/Fsn193MyProfile';
import Fsn24LogFood from '../screen/Fsn24LogFood';
import Fsn26LogWater from '../screen/Fsn26LogWater';
import { useEffect, useState } from "react";
import Fsn25LogSleep from '../screen/Fsn25LogSleep';
import Fsn27LogWeight from '../screen/Fsn27LogWeight';
import Fsn52LogMeditations from '../screen/Fsn52LogMeditations';
import Fsn2CoachChat from '../screen/fsn2/Fsn2CoachChat';
import Fsn117HealthyReads from '../screen/Fsn117HealthyReads';
import Fsn23LogActivity from '../screen/fsn23/Fsn23LogActivity';
import Fsn19ViewProfile from '../screen/Fsn19ViewProfile';
import Fsn8DoctorTimeSlotBooking from '../screen/fsn11/Fsn8DoctorTimeSlotBooking';
import GOQiiCashStatement from '../store/GOQiiCashStatement';



const useOnTap = () => {
  const [onTap, setOnTap] = useState(null);

  useEffect(() => {
    const storedData = localStorage.getItem("onTap");
    if (storedData) {
      setOnTap(JSON.parse(storedData));
    }
  }, []);

  return onTap;
};
const Fsn2CoachChatWrapper = () => <Fsn2CoachChat onTap={useOnTap()} />;

const Fsn8DoctorTimeSlotBookingWrapper = () => <Fsn8DoctorTimeSlotBooking onTap={useOnTap()} />;

const Fsn19ViewProfileWrapper = () => <Fsn19ViewProfile onTap={useOnTap()} />;
const Fsn23LogActivityWrapper = () => <Fsn23LogActivity onTap={useOnTap()} />;
const Fsn24LogFoodWrapper = () => <Fsn24LogFood onTap={useOnTap()} />;
const Fsn25LogSleepWrapper = () => <Fsn25LogSleep onTap={useOnTap()} />;
const Fsn26LogWaterWrapper = () => <Fsn26LogWater onTap={useOnTap()} />;
const Fsn27LogWeightWrapper = () => <Fsn27LogWeight onTap={useOnTap()} />;
const Fsn29CoachSelectionsWrapper = () => (
  <Fsn29CoachSelections onTap={useOnTap()} />
);

const Fsn37EditProfileWrapper = () => <Fsn37EditProfile onTap={useOnTap()} />;
const Fsn40PreferanceSettingsWrapper = () => (
  <Fsn40Prefrences onTap={useOnTap()} />
);
const Fsn41PrivacySettingsWrapper = () => (
  <Fsn41PrivacySettings onTap={useOnTap()} />
);
const Fsn44ProfileSettingWrapper = () => (
  <Fsn44ProfileSetting onTap={useOnTap()} />
);
const Fsn52LogMeditationsWrapper = () => (
  <Fsn52LogMeditations onTap={useOnTap()} />
);
const Fsn61WebViewWrapper = () => <Fsn61WebView onTap={useOnTap()} />;
const Fsn76WebViewWrapper = () => <Fsn76GenericUi onTap={useOnTap()} />;
const Fsn170Supportrapper = () => <Fsn170Support onTap={useOnTap()} />;
const Fsn117HealthyReadsWrapper = () => <Fsn117HealthyReads onTap={useOnTap()} />;
const Fsn136ChallengeLandingWrapper = () => <Fsn136ChallengeLanding onTap={useOnTap()} />;
const Fsn193MyProfileWrapper = () => <Fsn193MyProfile onTap={useOnTap()} />;
const Fsn223WebViewWrapper = () => <Fsn223WebView onTap={useOnTap()} />;
const GOQiiCashStatementWrapper = () => <GOQiiCashStatement onTap={useOnTap()} />;
const fsnRoutes = [
  

  { fsn: "2", route: "/fsn2", element: <Fsn2CoachChatWrapper /> },
  { fsn: "8", route: "/fsn8", element: <Fsn8DoctorTimeSlotBookingWrapper /> },
  { fsn: "19", route: "/fsn19", element: <Fsn19ViewProfileWrapper /> },
  { fsn: "23", route: "/fsn23", element: <Fsn23LogActivityWrapper /> },
  { fsn: "24", route: "/fsn24", element: <Fsn24LogFoodWrapper /> },
  { fsn: "25", route: "/fsn25", element: <Fsn25LogSleepWrapper /> },
  { fsn: "26", route: "/fsn26", element: <Fsn26LogWaterWrapper /> },
  { fsn: "27", route: "/fsn27", element: <Fsn27LogWeightWrapper /> },
  { fsn: "29", route: "/fsn29", element: <Fsn29CoachSelectionsWrapper /> },
  { fsn: "37", route: "/fsn37", element: <Fsn37EditProfileWrapper /> },
  { fsn: "40", route: "/fsn40", element: <Fsn40PreferanceSettingsWrapper /> },
  { fsn: "41", route: "/fsn41", element: <Fsn41PrivacySettingsWrapper /> },
  { fsn: "44", route: "/fsn44", element: <Fsn44ProfileSettingWrapper /> },
  { fsn: "52", route: "/fsn52", element: <Fsn52LogMeditationsWrapper /> },
  { fsn: "61", route: "/fsn61", element: <Fsn61WebViewWrapper /> },
  { fsn: "71", route: "/fsn193", element: <Fsn193MyProfileWrapper /> },
  { fsn: "76", route: "/fsn76", element: <Fsn76WebViewWrapper /> },
  { fsn: "117", route: "/fsn117", element: <Fsn117HealthyReadsWrapper /> },
  { fsn: "136", route: "/fsn136", element: <Fsn136ChallengeLandingWrapper /> },
  { fsn: "170", route: "/fsn170", element: <Fsn170Supportrapper /> },
  { fsn: "193", route: "/fsn193", element: <Fsn193MyProfileWrapper /> },
  { fsn: "223", route: "/fsn223", element: <Fsn223WebViewWrapper /> },
  { fsn: "300", route: "/fsnGOQiiCashStatement", element: <GOQiiCashStatementWrapper /> },
];

export default fsnRoutes;
